import styled from 'styled-components'
import { Dropdown, ListItemSkeleton } from '@sketch/components'
import { ReactComponent as ChatBubblesIcon } from '@sketch/icons/chat-bubbles-17'
import { breakpoint } from '@sketch/global-styles'

export const UnreadCommentIcon = styled(ChatBubblesIcon)`
  width: 17px;
  height: 17px;
  margin-left: auto;
  justify-self: end;
  color: ${({ theme }) => theme.colors.sketch.A};
`

export const SidebarItem = styled(Dropdown.Item.NavLink)`
  display: flex;
  align-items: center;
  gap: 8px;

  ${breakpoint('sm')`
    padding: 8px;
  `};
`

export const Skeleton = styled(ListItemSkeleton)`
  pointer-events: none;
  > span {
    height: 19px;
    margin: 8px 20px;
  }
`
